export default class SideBar {
    constructor() {
        this.editToggle = $('.edit-toggle');
        this.sideBar = $('.image-sidebar');
        this.setEventListeners();
    }

    setEventListeners() {
        this.editToggle.on('click', e => this.toggleSideBar());
    }

    toggleSideBar() {
        this.sideBar.toggleClass('show');
    }
}


// WEBPACK FOOTER //
// ./public/js/SideBar.js